// extracted by mini-css-extract-plugin
module.exports = {"clearfix":"AddressModal_clearfix__1fqy_","ellipsis":"AddressModal_ellipsis__1I4BG","hide":"AddressModal_hide__3quGk","title":"AddressModal_title__21QLz"};